
import { Component, Vue, Prop } from 'vue-property-decorator';
import CourtStamp from './CourtStamp.vue';

@Component({
    components: {
        CourtStamp
    }
})
export default class FormHeader extends Vue {
    @Prop({required: true})
    tableItems!: any;

}
